import { render, staticRenderFns } from "./formReferensiProduct.vue?vue&type=template&id=5c48c9df&scoped=true&"
import script from "./formReferensiProduct.vue?vue&type=script&lang=js&"
export * from "./formReferensiProduct.vue?vue&type=script&lang=js&"
import style0 from "./formReferensiProduct.vue?vue&type=style&index=0&id=5c48c9df&scoped=true&lang=css&"
import style1 from "./formReferensiProduct.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c48c9df",
  null
  
)

export default component.exports